// Traduit une requête API technique (méthode + chemin) en une phrase FR
// compréhensible pour un profil non-technique, dans la vue « Journal des requêtes »
// de l'admin. Ex. : GET /api/account/challenges/mine → « Consultation — Challenges ».

const VERB: Record<string, string> = {
  GET: "Consultation",
  POST: "Action",
  PUT: "Modification",
  PATCH: "Modification",
  DELETE: "Suppression",
};

// Règles ciblées (les chemins les plus parlants), testées dans l'ordre.
// `label` = nom de la ressource en clair ; le verbe est préfixé automatiquement,
// sauf si `override` fournit une phrase complète (ex. « Connexion »).
const RULES: { re: RegExp; label?: string; override?: string }[] = [
  { re: /^\/api\/auth\/(test-)?login/, override: "Connexion" },
  { re: /^\/api\/auth\/logout/, override: "Déconnexion" },
  { re: /^\/api\/auth\/(magic-link|request)/, override: "Demande de lien de connexion" },
  { re: /^\/api\/auth\/verify/, override: "Validation du lien de connexion" },
  { re: /^\/api\/signup/, override: "Inscription" },
  { re: /^\/api\/account\/company/, label: "Fiche entreprise" },
  { re: /^\/api\/account\/collaborators/, label: "Collaborateur" },
  { re: /^\/api\/(account\/)?offers/, label: "Offre" },
  { re: /^\/api\/(account\/)?personae/, label: "Persona" },
  { re: /^\/api\/account\/targets/, label: "Cas de simulation" },
  { re: /^\/api\/contexts/, label: "Contexte" },
  { re: /^\/api\/sessions\/[^/]+\/feedback/, label: "Feedback de session" },
  { re: /^\/api\/sessions\/[^/]+\/(scenario|realtime|messages)/, label: "Session vocale" },
  { re: /^\/api\/sessions/, label: "Session d'entraînement" },
  { re: /^\/api\/(account\/)?challenges/, label: "Challenge" },
  { re: /^\/api\/evaluation-criteria/, label: "Critère d'évaluation" },
  { re: /^\/api\/(account\/)?(licences|licence)/, label: "Licence" },
  { re: /^\/api\/admin\//, label: "Administration" },
  { re: /^\/api\/reporting/, label: "Reporting" },
  { re: /^\/api\/notifications/, label: "Notifications" },
  { re: /^\/api\/me\b/, label: "Son profil" },
];

function humanizeSegment(seg: string): string {
  if (!seg) return "";
  const s = seg.replace(/-/g, " ").replace(/_/g, " ");
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function describeRequest(method: string, path: string): string {
  const verb = VERB[method?.toUpperCase()] || method || "Requête";
  for (const r of RULES) {
    if (r.re.test(path)) {
      return r.override ?? `${verb} — ${r.label}`;
    }
  }
  // Fallback : ressource = 2ᵉ segment du chemin (après « api »), humanisée.
  const seg = path.split("/").filter(Boolean); // ["api","account","challenges",…]
  const resource = seg[0] === "api"
    ? (seg[1] === "account" ? seg[2] || seg[1] : seg[1])
    : seg[0];
  const human = humanizeSegment(resource || "");
  return human ? `${verb} — ${human}` : verb;
}
